/**
 * Hjelpemetoder for debug apiet til https://www.npmjs.com/package/debug
 */

import debuger, {Debugger} from "debug";

/** Aktiverer logging av meldinger generert via {@link Debugger}.
 * <pre>
 * Alternativt kan debug-logger aktiveres via (gjør aktiveringen persistent):
 * localStorage.debug = '*,-sockjs-client:*';
 * </pre>
 */
export function aktiverDebuggLogging(mønster = '*,-sockjs-client:*') {
    debuger.enable(mønster);
}

/** De-aktiverer logging av meldinger generert via {@link Debugger} */
export function deaktiverDebuggLogging() {
    debuger.disable();
}

/** Sørger for at kun meldingsargumenter som er referert via %j,%O osv blir inkludert.
 * Kan være nyttig ifbm tester som kjører i node og loguttrykk som logger hele modeller som fører til svært lange logmeldinger i node */
export function skjulEkstraLogArgumenter() {
    const opprinneligLog = debuger.log;
    debuger.log = (...args: any[]) => {
        if (args.length > 2) {
            const melding = args[0] as string;
            const meldingsargumenter = args.slice(1, -1)
            const antallErstatningsnøkler = (melding.match(/%\w/g) || []).length;
            const logmelding = melding + (meldingsargumenter.length > antallErstatningsnøkler ? ` (skjuler ${meldingsargumenter.length - antallErstatningsnøkler} arg)` : '');
            opprinneligLog.call(debuger, logmelding, ...meldingsargumenter.slice(0, antallErstatningsnøkler), args[args.length - 1]);
        } else
            opprinneligLog.call(debuger, ...args);
    }
}

/**
 * Returnerer {@link Debugger} instans registrert under angitt navn.
 * <pre>
 * Støttede formateringsopsjoner:
 *
 * %O	Pretty-print an Object on multiple lines.
 * %o	Pretty-print an Object all on a single line.
 * %s	String.
 * %d	Number (both integer and float).
 * %j	JSON. Replaced with the string '[Circular]' if the argument contains circular references.
 * %%	Single percent sign ('%'). This does not consume an argument.
 *
 * Eks:
 * const debug = initDebugger('etNavn')
 * debug('en streng %j', etJsonObjekt)
 * </pre>
 */
export function initDebugger(navn: string): Debugger {
    return require('debug')(navn);
}
